import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import logo from "../assets/img/logo.webp";
import { useParams } from "react-router-dom";
import dataJson from "../assets/json/datos.json";

export default function Footer() {
  const { sede } = useParams();
  const footerData = dataJson[sede]?.footer || {};

  return (
    <footer style={{ backgroundColor: "#808080ff", color: "#000" }}>
      <Container fluid className="py-4">
        <Row className="align-items-center text-center text-md-start">
          {/* Logo */}
          <Col md={4} className="mb-3 mb-md-0 d-flex justify-content-center">
            <img src={logo} alt="UNO" style={{ maxWidth: "250px" }} />
          </Col>

          {/* Información de contacto */}
          <Col md={5} className="mb-3 mb-md-0">
            {footerData.edificios?.map((edificio, i) => (
              <p key={i} style={{ margin: 0, color: "white" }}>
                <strong>{edificio.nombre}:</strong> {edificio.direccion} <br />
                {edificio.telefono && (
                  <>
                    Telf: {edificio.telefono} <br />
                  </>
                )}
                {edificio.fax && (
                  <>
                    Fax: {edificio.fax} <br />
                  </>
                )}
              </p>
            ))}

            {footerData.email && (
              <a href={`mailto:${footerData.email}`} style={{ color: "#fff" }}>
                {footerData.email}
              </a>
            )}
          </Col>

          {/* Redes sociales */}
          <Col md={3}>
            <h5 className="mb-2" style={{ color: "#fff" }}>
              Universidad UNO
            </h5>

            <div className="d-flex justify-content-center justify-content-md-start gap-3">
              {footerData.redes?.instagram && (
                <a
                  href={footerData.redes.instagram}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#fff" }}
                >
                  <FaInstagram size={24} />
                </a>
              )}

              {footerData.redes?.facebook && (
                <a
                  href={footerData.redes.facebook}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#fff" }}
                >
                  <FaFacebook size={24} />
                </a>
              )}

              {footerData.redes?.tiktok && (
                <a
                  href={footerData.redes.tiktok}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#fff" }}
                >
                  <FaTiktok size={24} />
                </a>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      {/* Copyright */}
      <div
        style={{ backgroundColor: "#002b6c", color: "#fff" }}
        className="text-center py-2"
      >
        <small>
          © Copyright 2026 UNIVERSIDAD NACIONAL DEL ORIENTE. Todos los Derechos
          Reservados
        </small>
      </div>
    </footer>
  );
}
